import React from 'react';
import {Box, Typography} from '@mui/material';
import {styled} from '@mui/material/styles';

import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';

const ERROR_ICON_SIZE='64px';

const ErrorContainer = styled(Box)(()=>({
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    alignItems: 'center',
    gap: '16px',
}));

export default function ErrorMessage({title, subtitle, children, className=''}) {
    return (
      <ErrorContainer className={className}>
        <ReportProblemOutlinedIcon color='error' sx={{height: ERROR_ICON_SIZE, width: ERROR_ICON_SIZE}} />
        <Typography color='error' variant='h5'>{title}</Typography>
        <Typography variant='h6'>{subtitle}</Typography>
        {children}
      </ErrorContainer>
    );
}
